export const T = {
    menu: {
        focus: 'F©US RPG',
        mechanics: 'Zasady',
        combat: 'Walka',
        travel: 'Travel',
        character: 'Postać',
        skills: "Zdolności",
        backpack: 'Plecak',
        magic: 'Magia',
        fall: 'Upadek',
        bestiary: 'Bestiariusz',
        contact: 'Kontakt'
    }
}

